import React, { useCallback } from 'react';
import { Play } from 'lucide-react';
import { toast } from 'react-toastify';

import {
  getGetBuslineImportsQueryOptions,
  useExecuteTodayBuslineImports,
} from '@area-restrita/api-client/endpoints/busline-imports/busline-imports.gen';

import { useQueryTable } from '@/hooks/useQueryTable';
import PageContainer from '@/components/layout/PageContainer';
import DataGrid from '@/components/DataGrid';
import { Button } from '@/components/ui/button';
import Dialog from '@/components/template/Dialog';
import DataTableFacetedFilter from '@/components/DataTable/DataTableFacetedFilter';

import ImportDialog from './ImportDialog';
import { columns } from './columns';

const BuslineImports: React.FC = () => {
  const { mutate: executeTodayBuslineImports, isPending } =
    useExecuteTodayBuslineImports();

  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns,
    getQueryOptions: getGetBuslineImportsQueryOptions,
  });

  const status = table.getColumn('status')?.getFilterValue() as
    | string[]
    | undefined;

  const handleExecuteImports = useCallback(() => {
    executeTodayBuslineImports(undefined, {
      onSuccess: () => toast.success('Importação executada com sucesso.'),
      onError: () => toast.error('Erro ao executar a importação.'),
    });
  }, [executeTodayBuslineImports]);

  return (
    <PageContainer
      title="Importação de Rotas"
      subtitle="Gerencie a importação de rotas de ônibus."
    >
      <DataGrid
        variant="card"
        table={table}
        isLoading={isLoading}
        actions={
          <>
            {(!status?.length || status.includes('pending')) && (
              <Button
                variant="outline"
                size="sm"
                loading={isPending}
                onClick={handleExecuteImports}
              >
                <Play className="size-4" />
                Executar
              </Button>
            )}
            <Dialog
              title="Nova Importação de Rotas"
              trigger={<Button size="sm">Nova Importação</Button>}
            >
              <ImportDialog />
            </Dialog>
          </>
        }
        toolbar={
          <DataTableFacetedFilter
            title="Status"
            options={[
              { label: 'Agendado', value: 'pending' },
              { label: 'Executado', value: 'executed' },
              { label: 'Falhou', value: 'failed' },
            ]}
            column={table.getColumn('status')}
          />
        }
      />
    </PageContainer>
  );
};

export default BuslineImports;
